import "./DownloadFormBtn.scss";
import { MdOutlineFileDownload } from "react-icons/md";

const DownloadFormBtn = ({ btnName, titleFontSize , onClick , file}) => {

    const handleClick = () => {
        if (onClick) onClick();        
        if (file) window.open(file, "_blank"); 
      };
    return (
        <button className="downloadBtnParent" onClick={handleClick} >
            <div>
                <span>
                    <MdOutlineFileDownload size="1.8rem" />
                </span>
            </div>
            <div>
                {btnName && (<span style={{ fontSize: `${titleFontSize}` }} className="btnNamez">{btnName} </span>)}
            </div>
        </button>
    )
}

export default DownloadFormBtn;
